__turbopack_context__.v({
  "card": "PortalDirectory-module__BjoJya__card",
  "cardAction": "PortalDirectory-module__BjoJya__cardAction",
  "cardBody": "PortalDirectory-module__BjoJya__cardBody",
  "cover": "PortalDirectory-module__BjoJya__cover",
  "empty": "PortalDirectory-module__BjoJya__empty",
  "grid": "PortalDirectory-module__BjoJya__grid",
  "hint": "PortalDirectory-module__BjoJya__hint",
  "intro": "PortalDirectory-module__BjoJya__intro",
  "listingIntro": "PortalDirectory-module__BjoJya__listingIntro",
  "monogram": "PortalDirectory-module__BjoJya__monogram",
  "pagination": "PortalDirectory-module__BjoJya__pagination",
  "rail": "PortalDirectory-module__BjoJya__rail",
  "railControls": "PortalDirectory-module__BjoJya__railControls",
  "railHeading": "PortalDirectory-module__BjoJya__railHeading",
  "railTrack": "PortalDirectory-module__BjoJya__railTrack",
  "railViewport": "PortalDirectory-module__BjoJya__railViewport",
  "rails": "PortalDirectory-module__BjoJya__rails",
  "reset": "PortalDirectory-module__BjoJya__reset",
  "results": "PortalDirectory-module__BjoJya__results",
  "toolbar": "PortalDirectory-module__BjoJya__toolbar",
});
